import Component from 'components/component';
import DownloadSlider from 'components/download-slider-new';
import Dropdown from 'components/dropdown';
import MylistModal from 'components/my-lists-modal';
import Tooltip from 'components/tooltip';
import Cookies from 'js-cookie';
import { DI } from 'modules';
import React, { Fragment } from 'react';
import ReactGA from 'react-ga';
import { withRouter } from 'react-router';
import DownloadSliderInner from './download-slider-inner';
import Login from './login';
import Restrictions from './restrictions';
import { AGREEMENT_TYPE, DOWNLOAD_TYPE } from 'components/download-slider-new/constants';

const DEFAULT_FORMAT_COOKIE_KEY = 'default_video_format';

class PanelDownload extends React.Component {
  state = {
    drawer: false,
    agreed: false,
  };

  openDrawer() {
    this.setState({ drawer: true });
    this.props.actions.videos.sendStatsHit(
      this.props.searchKey,
      this.props.entity.external_name,
      'click_download',
    );
  }

  closeDrawer() {
    this.setState({ drawer: false });
  }

  onChangeAgreed(agreed) {
    this.setState({ agreed });
  }

  onSubmit = (form, agreement) => {
    const {
      entity: video,
      common: { cookiesAccepted: { functional } },
    } = this.props;
    const can_download = agreement?.can_download_content || {};
    const {
      one_off_already_downloaded_branding_types: one_off_DBT = [],
      download_type,
      allowed_branding_types,
    } = can_download;
    const credit = video.exclusive && allowed_branding_types.includes('credit');
    const logo = video.exclusive && allowed_branding_types.includes('logo');
    const isRepeated = (() => {
      if (download_type === AGREEMENT_TYPE.ONE_OFF && one_off_DBT.length) {
        return one_off_DBT.includes(form.branding_type);
      }

      return download_type === DOWNLOAD_TYPE.REPEATED && !video.free_access;
    })();
    const isFree = download_type === DOWNLOAD_TYPE.FREE;
    const isOneOff = agreement?.agreement_type === AGREEMENT_TYPE.ONE_OFF || !agreement;

    const [quality, extension, file_type] = form.format.split(';');
    const branded = form.branding_type === 'branded' || logo;
    const previewDownload = form.format === 'md;mp4;screener_free';

    functional &&
      Cookies.set(DEFAULT_FORMAT_COOKIE_KEY, form.format, {
        expires: 10 * 365,
      });

    const params = {
      repeated: isRepeated,
      agreement_id: agreement.id,
      project_id: video.inner_id,
      project_slug: video.id,
      download_to_sftp: form.download_to_sftp,
      video_format: {
        quality,
        extension,
        brand_position: form.branding_position || 'without_brand',
        file_type:
          (branded && file_type === 'normal') || logo
            ? 'branded'
            : credit && file_type === 'normal'
              ? 'credit'
              : file_type,
      },
    };

    const download = () => {
      if (previewDownload) {
        this.props.actions.videos.previewDownloadVideo(video.preview_url).then(() => {
          this.props.onDownload();
          this.closeDrawer();
        });
      } else {
        this.props.actions.videos.downloadVideo(params).then(() => {
          this.props.onDownload();
          this.closeDrawer();
        });
      }
    };

    if (isRepeated || isFree) {
      download();
    } else {
      if (isOneOff) {
        delete params.repeated;
        this.props.actions.common.updateSearchParams(
          params,
          true,
          `/${this.props.common.locale}/payment/video`,
        );
      } else {
        download();
      }
    }
    this.props.actions.videos.sendStatsHit(
      this.props.searchKey,
      video.external_name,
      'click_buy',
    );
  };

  openMyListModal = () => {
    this.props.actions.common.openNewListModal();
  };

  closeMyListModal = title => {
    if (title && title.length) {
      ReactGA.event({
        category: this.props.location.pathname,
        action: 'Add to list',
        label: title,
      });
    }
    this.props.actions.common.closeNewListModal();
  };

  confirmMyListModal = title => {
    const video = {
      item_type: 'video_project',
      item_id: this.props.entity.id,
    };

    const user_id = this.props.user.currentUser.payload.id;

    this.props.actions.user.createList(user_id, title, [], [video]).then(
      () => {
        this.props.actions.user.getVideoLists({
          video_id: this.props.entity.inner_id,
        });
        this.closeMyListModal(title);
      },
      this.props.actions.notifications.createNotification({
        type: 'success',
        children: this.props.common.strings['page.profile.menu.after_update'],
      }),
    );
  };

  selectList = (ev, list_id, item) => {
    const myList = this.props.user.myVideoLists.payload;

    const currentList = myList.lists.find(l => l.slug == list_id);
    const inList = myList.lists_with_video.includes(currentList.id);

    if (inList) {
      this.props.actions.notifications.createNotification({
        type: 'notify',
        children: this.props.common.strings['page.my_lists.video_exists'],
      });
    } else {
      const video = this.props.entity;
      this.props.actions.user.addListItem('video_project', video.id, list_id).then(
        () => {
          this.props.actions.user.getVideoLists({
            video_id: this.props.entity.inner_id,
          });
          this.closeMyListModal(item.title);
        },
        this.props.actions.notifications.createNotification({
          type: 'success',
          children: this.props.common.strings[
            'page.profile.menu.after_update'
          ],
        }),
      );
    }
  };


  render() {
    const {
      user,
      entity,
      common,
    } = this.props;

    const isPreviewAllowed = this.props.user.currentUser.payload.company;
    const myLists = this.props.user.myVideoLists.payload.lists;

    const {
      strings,
      newListModal,
    } = common;

    const { restrictions } = entity;

    const showRestrictions = Boolean(entity.restrictions);

    const downloadableEnabled = entity.downloadable === 'enabled';

    const availableFormatsPayload =
      this.props.videos.availableFormats.payload || {};
    const formats = [
      ...availableFormatsPayload.clean,
      ...availableFormatsPayload.branded,
      ...availableFormatsPayload.credit,
    ].map(
      format => `${format.quality};${format.extension};${format.file_type}`,
    );
    const defaultFormat = formats.includes(
      Cookies.get(DEFAULT_FORMAT_COOKIE_KEY),
    )
      ? Cookies.get(DEFAULT_FORMAT_COOKIE_KEY)
      : null;

    const modList = typeof myLists !== 'undefined' ? myLists.slice() : [];

    modList.push({
      title: strings['page.my_lists.add_list_new'],
      onClick: this.openMyListModal,
      slug: '',
      id: '',
    });

    const listsWithVideo = this.props.user.myVideoLists.payload.lists_with_video;

    return (
      <div className='live-block'>
        {entity.limit_type === 'pool' && (
          <Mark
            text={`Pool ${strings['page.lives.view.pool_description']}`}
            tooltip={strings['page.video.left.pool.info']}
          />
        )}
        {entity.free_access && (
          <Mark
            text={`Free ${strings['page.lives.view.free_description']}`}
            tooltip={strings['page.video.left.free.info']}
          />
        )}
        {(showRestrictions || downloadableEnabled) ? (
          <div className='live-subblock'>
            {showRestrictions && (
              <Restrictions
                restrictions={restrictions}
                downloadableEnabled={downloadableEnabled}
                agreed={this.state.agreed}
                onChange={ev => this.onChangeAgreed(ev.target.checked)}
                user={user}
              />
            )}
            {downloadableEnabled && (
              <Fragment>
                {user.isSignedIn ? (
                  <div
                    className={Component.classList(
                      'live-download',
                      !showRestrictions && 'live-download--not-padded',
                    )}
                  >
                    <button
                      type='button'
                      className='button'
                      onClick={() => this.openDrawer()}
                      disabled={showRestrictions ? !this.state.agreed : false}
                      data-action-name="open download slider"
                    >
                      {strings['page.video.left.download']}
                    </button>
                    <div className='live-download__select'>
                      <Dropdown
                        headerModificator={['big dropdown__head--green']}
                        bodyModificator={['to-list']}
                        items={modList}
                        // video={this.props.entity}
                        listsWithVideo={listsWithVideo}
                        placeholder={strings['page.my_lists.add_list']}
                        getTitle={item => item.title}
                        getValue={item => item.slug}
                        onChange={this.selectList}
                      />
                    </div>
                    {this.state.drawer && (
                      <DownloadSlider
                        onClose={() => this.closeDrawer()}
                        onSubmit={(form, agreement) =>
                          this.onSubmit(form, agreement)
                        }
                        agreements={user.activeVodAgreements.payload}
                        entity={entity}
                        innerComponent={DownloadSliderInner}
                        innerProps={{
                          defaultFormat,
                          allowedPreview: isPreviewAllowed,
                        }}
                        getHints={(form, agr) =>
                          [
                            !form.agreement_id && strings['page.video.slider.agreement'],
                            entity.limit_type !== "spherical" && !form.format && !defaultFormat && 'Format',
                            (form.format || defaultFormat) && ['branded', 'credit'].includes(form.branding_type) &&
                            !form.branding_position && 'Branding position',
                          ].filter(Boolean)
                        }
                        buttonProps={{
                          link: entity.preview_file_url,
                        }}
                      />
                    )}
                  </div>
                ) : (
                  <Login withRestrictions={!!restrictions} />
                )}

                {newListModal && (
                  <MylistModal
                    close={this.closeMyListModal}
                    confirm={this.confirmMyListModal}
                    title={strings['page.my_lists.add_list_new']}
                    placeholder={strings['page.my_lists.list.modal.list_name']}
                  />
                )}
              </Fragment>
            )}
          </div>
        ) : <div className='live-subblock'>Unabled to download</div>}
      </div>
    );
  }
}

function Mark({
  text,
  tooltip,
}) {
  return (
    <div className='live-subblock'>
      <div className='live-mark live-mark--not-padded'>
        <span className='live__mark'>{text}</span>
        <Tooltip content={tooltip}>
          <span className='question' />
        </Tooltip>
      </div>
    </div>
  );
}

export default DI(['common', 'user', 'videos', 'notifications'])(
  withRouter(PanelDownload),
);
